import { combineReducers } from 'redux';

import { FAILURE_ACCOUNT_GAINS, RECEIVE_ACCOUNT_GAINS, REQUEST_ACCOUNT_GAINS } from './constants';
import { RESET_ACCOUNT_USER } from '../constants';
import { nowTimestampPlusHour } from '../../../utils/dateUtils';

/*
 * State shape
{
    gains : {...},
    expireAt: timestamp,
    fetching: false,
    error: ''
}
*/

const gains = (state = null, action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_GAINS:
            return action.response.payload;
        case RESET_ACCOUNT_USER:
            return null;
        default:
            return state;
    }
};

const expireAt = (state = 0, action) => {
    switch (action.type) {
        case RECEIVE_ACCOUNT_GAINS:
            return nowTimestampPlusHour(1);
        case RESET_ACCOUNT_USER:
            return 0;
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_ACCOUNT_GAINS:
            return true;
        case FAILURE_ACCOUNT_GAINS:
        case RECEIVE_ACCOUNT_GAINS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_ACCOUNT_GAINS:
            return action.response.message;
        case REQUEST_ACCOUNT_GAINS:
        case RECEIVE_ACCOUNT_GAINS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    gains,
    expireAt,
    fetching,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/gains/reducer.js